import React from 'react';
import {useSelector} from 'react-redux';
import {
  selectGameResults,
  selectPhase,
  selectRound,
  selectWarPhaseStage
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {
  selectIsCityCaptureAnimationPlaying,
  selectIsRuinsIncomeAnimationPlaying,
} from "../../../redux/reducers/privateStateReducer/selectors";
import {PHASES} from "../../../constants/phases";
import {getPhaseShortName} from "../../../utils/phase/getPhaseShortName";
import {getPhaseIcon} from "../../../utils/phase/getPhaseIcon";
import {checkIfAnyGamePreparationPhase} from "../../../utils/checkIfAnyGamePreparationPhase";
import {EngravedIcon} from "../../gameUi/EngravedIcon";
import WarPhaseStagesPanel from "../../WarPhaseStagesPanel/WarPhaseStagesPanel";
import './HeaderPhaseZone.css';

const GAME_GOAL_HINT = 'Цели игры: набрать как можно большее очков.\n\nМатч состоит из 13 раундов.\n\n'
  + 'Каждый раунд состоит из 3 фаз:\n1) Снабжение\n2) Строительство\n3) Война\n\n'
  + 'В последних 3 раундах доход очков Руин и Великих руин увеличен x2.\n\n'
  + 'В конце игры все оставшиеся монеты переводятся в очки по курсу 2 к 1.';

// Пока камера облетает захваченные города (см. scenes/CityCaptureAnimation),
// шапка говорит, что сейчас происходит: ход нового раунда уже начался, но
// его время не идет — сервер добавил его на облет (getCityCaptureStageExtraMs)
const CITY_CAPTURE_TEXT = 'Захват городов';
const CITY_CAPTURE_ICON = '/img/icons/central quarter flag.png';
// Рост дохода руин (см. scenes/RuinsIncomeAnimation): шапка серая, цвета очков
const RUINS_INCOME_TEXT = 'Доход руин';
const RUINS_INCOME_ICON = '/img/icons/win points white.png';

/**
 * Центр шапки: раунд и фаза («Раунд 3 · Строительство»), в войне — строка
 * этапов с выделенным текущим (вместо прежнего лотка под шапкой)
 */
const HeaderPhaseZone = () => {
  const round = useSelector(selectRound);
  const phase = useSelector(selectPhase);
  const warStage = useSelector(selectWarPhaseStage);
  const gameResults = useSelector(selectGameResults);
  const isCityCaptureAnimationPlaying = useSelector(selectIsCityCaptureAnimationPlaying);
  const isRuinsIncomeAnimationPlaying = useSelector(selectIsRuinsIncomeAnimationPlaying);

  const isPreparation = checkIfAnyGamePreparationPhase(phase);
  let stageText;
  let phaseText = null;
  if (isCityCaptureAnimationPlaying) {
    stageText = CITY_CAPTURE_TEXT;
  } else if (isRuinsIncomeAnimationPlaying) {
    stageText = RUINS_INCOME_TEXT;
  } else if (gameResults) {
    stageText = 'Игра завершена';
  } else if (isPreparation) {
    stageText = 'Подготовка';
    phaseText = getPhaseShortName(phase);
  } else {
    stageText = `Раунд ${round}`;
    phaseText = getPhaseShortName(phase);
  }

  const isWar = !gameResults && !isCityCaptureAnimationPlaying && !isRuinsIncomeAnimationPlaying && phase === PHASES.WAR;
  let phaseIcon = getPhaseIcon(phase, warStage, gameResults);
  if (isCityCaptureAnimationPlaying) {
    phaseIcon = CITY_CAPTURE_ICON;
  } else if (isRuinsIncomeAnimationPlaying) {
    phaseIcon = RUINS_INCOME_ICON;
  }

  return (
    <div className={'header-phase-zone'} title={GAME_GOAL_HINT} data-war={isWar || undefined}>
      {/* В войне иконка фазы повторяла бы иконку текущего этапа */}
      {!isWar && (
        <EngravedIcon
          src={phaseIcon}
          size={22}
          alt={''}
          className={'header-phase-zone_icon'}
        />
      )}
      <span className={'header-phase-zone_text'}>
        <span className={'header-phase-zone_round'}>{stageText}</span>
        {phaseText && (
          <>
            <span className={'header-phase-zone_separator'} aria-hidden={'true'}>{'·'}</span>
            <span className={'header-phase-zone_phase'}>{phaseText}</span>
          </>
        )}
      </span>
      {isWar && <WarPhaseStagesPanel className={'header-phase-zone_stages'}/>}
    </div>
  );
};

export default HeaderPhaseZone;
